import { render, staticRenderFns } from "./DisableAutoPublishModal.vue?vue&type=template&id=6e89bd7b"
import script from "./DisableAutoPublishModal.vue?vue&type=script&lang=js"
export * from "./DisableAutoPublishModal.vue?vue&type=script&lang=js"
import style0 from "./DisableAutoPublishModal.vue?vue&type=style&index=0&id=6e89bd7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports